import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs';

import { CookieService } from './cookie.service';
import { default as swal } from 'sweetalert2';


export class AuthHttpClient {

	public baseUrl: string;
	public token: string;

	constructor(
		private http: Http,
		private cookieService: CookieService) {
			this.baseUrl = process.env.GATEWAY_URL;
			this.setToken();
	}

	public getBaseUrl(): string {
		return this.baseUrl;
	}

	public getToken(): string {
		return this.token;
	}

	public get(url: string, options?: RequestOptions, headers?: any) {
		let reqHeaders = new Headers(headers);

		let reqOptions = {
			headers: this.createAuthorizationHeader(reqHeaders)
		};
		if (options) {
			reqOptions['search'] = options;
		}

		return this.intercept(this.http.get(this.baseUrl + url, new RequestOptions(reqOptions)));
	}

	public post(url: string, body: string, reqHeaders?: Headers, options?: RequestOptions) {
		if (!reqHeaders) {
			reqHeaders = new Headers({ 'Content-Type': 'application/json' });
		} else {
			reqHeaders.append('Content-Type',  'application/json');
		}

		let reqOptions = {
			headers: this.createAuthorizationHeader(reqHeaders)
		};
		if (options) {
			reqOptions['search'] = options;
		}

		return this.intercept(this.http.post(this.baseUrl + url, body, new RequestOptions(reqOptions)));
	}

	public postMultipart(url: string, body: FormData) {
		// no Content-Type header — the browser sets multipart/form-data with the boundary
		let reqOptions = {
			headers: this.createAuthorizationHeader(new Headers())
		};

		return this.intercept(this.http.post(this.baseUrl + url, body, new RequestOptions(reqOptions)));
	}

	public put(url: string, body: string, reqHeaders?: Headers, options?: RequestOptions) {
		if (!reqHeaders) {
			reqHeaders = new Headers({ 'Content-Type': 'application/json' });
		} else {
			reqHeaders.append('Content-Type',  'application/json');
		}

		let reqOptions = {
			headers: this.createAuthorizationHeader(reqHeaders)
		};
		if (options) {
			reqOptions['search'] = options;
		}

		return this.intercept(this.http.put(this.baseUrl + url, body, new RequestOptions(reqOptions)));
	}

	public patch(url: string, body: string, reqHeaders?: Headers, options?: RequestOptions) {
		if (!reqHeaders) {
			reqHeaders = new Headers({ 'Content-Type': 'application/json' });
		} else {
			reqHeaders.append('Content-Type',  'application/json');
		}

		let reqOptions = {
			headers: this.createAuthorizationHeader(reqHeaders)
		};
		if (options) {
			reqOptions['search'] = options;
		}

		return this.intercept(this.http.patch(this.baseUrl + url, body, new RequestOptions(reqOptions))
			.catch((error) => {
				if (error.status !== 405) {
					return Observable.throw(error);
				}

				// try POST method as fallback
				return this.http.post(this.baseUrl + url, body, new RequestOptions(reqOptions));
			})
		);
	}

	public delete(url: string, options?: RequestOptions, reqHeaders?: Headers) {
		if (!reqHeaders) {
			reqHeaders = new Headers();
		}

		let reqOptions = {
			headers: this.createAuthorizationHeader(reqHeaders)
		};
		if (options) {
			reqOptions['search'] = options;
		}

		return this.intercept(this.http.delete(this.baseUrl + url, new RequestOptions(reqOptions)));
	}

	private setToken() {
		let cookieData = this.cookieService.get();
		if (typeof cookieData !== 'undefined' && cookieData.token) {
			this.token = cookieData.token;
		}
	}

	private createAuthorizationHeader(headers: Headers) {
		headers.append('Authorization', 'Bearer ' + this.token);
		return headers;
	}

	private intercept(requestObservable: Observable<any>): Observable<any> {
		return requestObservable.do(
			() => undefined
		);
	}
static ctorParameters() { return [ { type: Http }, { type: CookieService } ]; }}



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/providers/auth-http.service.ts